import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  CLEAR_GPS_SOURCE,
  ON_MESSAGE,
  SET_GPS_DATA,
  TOGGLE_SAVE_GPS_SOURCE,
  WS_CONNECTION,
} from './actions';
import { WEB_SOCKET_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

const initialState = {
  latitude: 0,
  longitude: 0,
  wsStatus: 2,
  gps_status: 0,
  gpsSources: [],
  saveGPS: false,
};

const reducer = handleActions({
  [WEB_SOCKET_MODULE + WS_CONNECTION + FAILED]: state => ({
    ...state,
    wsStatus: 2,
  }),
  [WEB_SOCKET_MODULE + WS_CONNECTION]: state => ({
    ...state,
    wsStatus: 1,
  }),
  [WEB_SOCKET_MODULE + WS_CONNECTION + SUCCESSFUL]: state => ({
    ...state,
    wsStatus: 0,
  }),
  [WEB_SOCKET_MODULE + TOGGLE_SAVE_GPS_SOURCE]: (state, action) => ({
    ...state,
    saveGPS: action.payload,
  }),
  [WEB_SOCKET_MODULE + CLEAR_GPS_SOURCE]: state => ({
    ...state,
    // gpsSources: [],
  }),
  [WEB_SOCKET_MODULE + SET_GPS_DATA]: (state, action) => {
    const { raw = {}, data = {} } = action.payload;
    const {
      latitude,
      longitude,
    } = data;
    const { gpsSources } = state;
    let newList = [...gpsSources, raw];
    const max = 2000;
    const len = newList.length;
    if (len > max) {
      newList = newList.slice(len - max);
    }
    return {
      ...state,
      gpsSources: state.saveGPS ? newList : state.gpsSources,
      latitude,
      longitude,
      wsStatus: 0,
    };
  },
}, initialState);

export default reducer;

export const getWSData = createSelector(
  [state => state[WEB_SOCKET_MODULE]],
  state => {
    const {
      latitude,
      longitude,
      wsStatus,
      gpsSources = [],
      saveGPS,
      gps_status,
    } = state;
    return {
      latitude,
      longitude,
      wsStatus,
      gpsSources,
      saveGPS,
      gps_status,
    };
  },
);
